import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
/**
 * Default assets for the Member Payment Card Wallet component.
 */
export const defaultMemberPaymentCardWalletAssets = {
    failedToLoadDataIconName: 'generic-error-message',
    failedToInitialiseConnectorIconName: 'generic-error-message',
    addCardFailedIconName: 'payment-error-message',
    cardDeclinedIconName: 'payment-error-message',
    connectorLoadingIconName: 'spinner',
    addCardButtonIconName: 'plus-circle',
    removeCardButtonIconName: 'trash',
    defaultCardIconName: 'credit-card',
    expiredCardIconName: 'credit-card-strike',
    processingAddCardIconName: 'spinner'
};
export const memberPaymentCardWalletAssetsValidator = Validator.object({
    failedToLoadDataIconName: nonEmptyStringValidator,
    failedToInitialiseConnectorIconName: nonEmptyStringValidator,
    addCardFailedIconName: nonEmptyStringValidator,
    cardDeclinedIconName: nonEmptyStringValidator,
    connectorLoadingIconName: nonEmptyStringValidator,
    addCardButtonIconName: nonEmptyStringValidator,
    removeCardButtonIconName: nonEmptyStringValidator,
    defaultCardIconName: nonEmptyStringValidator,
    expiredCardIconName: nonEmptyStringValidator,
    processingAddCardIconName: nonEmptyStringValidator
});
